import { createContext } from "react";

// O periodo que vai no nome de cada ficheiro de "Descarregar esta tabela" (AAAA-MM-DD-AAAA-MM-DD), dado
// pela pagina de analytics (entrega 5 do redesign). Fora dela o nome fica so com o titulo.
export const DownloadPeriodContext = createContext("");
